import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { IconClose } from "./icons";

// Floating, scrollable review/edit modal shell. The form passes the merged,
// editable fields + footer as children. Closing keeps form state intact (the
// user can reopen and nothing is lost). Esc / backdrop / X all close.
const ReviewModal = ({ open, title, subtitle, onClose, children }) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden"; // lock page scroll behind the modal
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  // Portal to <body> so the overlay escapes the careers page's stacking context
  // (.crs-stage z-index:2) and sits above the sticky header / side CTAs.
  return createPortal(
    <div
      className="crs-modal-overlay"
      onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="crs-modal" role="dialog" aria-modal="true" aria-label={title}>
        <div className="crs-modal__head">
          <div className="crs-modal__head-text">
            {subtitle && <p className="crs-card__head-eyebrow">{subtitle}</p>}
            <h2>{title}</h2>
          </div>
          <button type="button" className="crs-modal__close" onClick={onClose} aria-label="Close review">
            <IconClose />
          </button>
        </div>
        <div className="crs-modal__body">{children}</div>
      </div>
    </div>,
    document.body
  );
};

export default ReviewModal;
